import { useWorkspace } from '@/composables/useWorkspace';
import { getOffersApiRequest } from '@/services/api/offers-api';
import { useStore } from '@/store';

export const populateOffersStoreCacheApiRequest = async () => {
  const store = useStore();
  const payload = await getOffersApiRequest({
    status: 'active',
    limit: '200',
    columns: [
      'id',
      'name',
      'nameFull',
      'countryId',
      'workspaceId',
      'affiliateNetworkId',
      'affiliateNetworkName',
      'countryName',
      'url',
    ],
    orderBy: 'updated',
    orderDirection: 'desc',
  });
  store.cache.populateOffersCache(payload);
  return payload;
};

export const updateOffersStoreCacheApiRequest = async ({
  workspaceId,
  countryId,
}: {
  workspaceId: string;
  countryId: number;
}) => {
  const store = useStore();
  const workspaceApi = useWorkspace();
  const payload = await getOffersApiRequest({
    status: 'active',
    limit: '200',
    columns: [
      'id',
      'name',
      'nameFull',
      'countryId',
      'workspaceId',
      'affiliateNetworkId',
      'affiliateNetworkName',
      'countryName',
      'url',
    ],
    orderBy: 'updated',
    orderDirection: 'desc',
    workspaceIds: [...new Set([workspaceId, ...workspaceApi.allPublicWorkspacesIds.value])],
    ...(countryId !== 0 && { countryId }),
  });
  store.cache.updateOffersCache({
    workspaceId,
    countryId,
    data: payload,
  });
  return payload;
};
